var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "v-dialog",
        { attrs: { value: _vm.value, persistent: "", width: "800" } },
        [
          _c(
            "v-card",
            { staticClass: "modalCard" },
            [
              _c(
                "v-toolbar",
                { staticClass: "main", attrs: { flat: "", dark: "" } },
                [
                  _c("v-toolbar-title", [_vm._v("Exports")]),
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { text: "", color: "grey darken-2" },
                      on: {
                        click: function ($event) {
                          return _vm.$emit("close")
                        },
                      },
                    },
                    [_c("v-icon", [_vm._v("mdi-close")])],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-toolbar",
                { attrs: { flat: "", color: "toolbar" } },
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "5" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          label: "Filter",
                          placeholder: "Filter user exports by file name",
                          "prepend-inner-icon": "mdi-filter-outline",
                          "hide-details": "auto",
                          "background-color": "input",
                          dense: "",
                          outlined: "",
                          clearable: "",
                        },
                        model: {
                          value: _vm.filterText,
                          callback: function ($$v) {
                            _vm.filterText = $$v
                          },
                          expression: "filterText",
                        },
                      }),
                    ],
                    1
                  ),
                  _c("v-spacer"),
                  _c("v-checkbox", {
                    staticClass: "mr-4 mt-0 pt-0 shrink",
                    attrs: {
                      label: "Include current search filters in export",
                      "hide-details": "",
                    },
                    model: {
                      value: _vm.includeFilters,
                      callback: function ($$v) {
                        _vm.includeFilters = $$v
                      },
                      expression: "includeFilters",
                    },
                  }),
                  _c(
                    "v-btn",
                    {
                      staticClass: "white--text",
                      attrs: { color: "#0c67a5", disabled: _vm.loading },
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.createUserExport.apply(null, arguments)
                        },
                      },
                    },
                    [_vm._v(" Create Export ")]
                  ),
                ],
                1
              ),
              _c("v-data-table", {
                ref: "my-table",
                attrs: {
                  headers: _vm.headers,
                  items: _vm.filteredUserExports,
                  "items-per-page": _vm.pageSize,
                  "item-class": _vm.rowHighlight,
                  loading: _vm.loading,
                  height: 400,
                  dense: "",
                  "fixed-header": "",
                  "hide-default-footer": "",
                  "loading-text": "Loading... Please Wait",
                  "no-data-text": "No Exports Available",
                  "no-results-text": "No Matches Found",
                  "item-key": "export_id",
                },
                on: {
                  "update:items": function ($event) {
                    _vm.filteredUserExports = $event
                  },
                  "click:row": function ($event) {
                    _vm.highlighted = $event
                  },
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: `item.actions`,
                      fn: function ({ item }) {
                        return [
                          _c(
                            "v-icon",
                            {
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.downloadFile(item.export_id)
                                },
                              },
                            },
                            [_vm._v(" mdi-download ")]
                          ),
                        ]
                      },
                    },
                    {
                      key: `item.created_on`,
                      fn: function ({ item }) {
                        return [
                          _vm._v(
                            " " +
                              _vm._s(_vm.formatDateTimeAlt(item.created_on)) +
                              " "
                          ),
                        ]
                      },
                    },
                    {
                      key: "footer",
                      fn: function () {
                        return [
                          _c("v-divider"),
                          _c(
                            "v-toolbar",
                            { attrs: { flat: "", color: "toolbar" } },
                            [
                              _c("v-spacer"),
                              _c(
                                "v-col",
                                {
                                  staticStyle: { "max-width": "150px" },
                                  attrs: { cols: "2" },
                                },
                                [
                                  _c("v-select", {
                                    staticClass: "mt-8",
                                    attrs: {
                                      dense: "",
                                      items: _vm.pageSizes,
                                      label: "Items Per Page",
                                      "menu-props": {
                                        top: true,
                                        offsetY: true,
                                        maxHeight: 500,
                                      },
                                    },
                                    model: {
                                      value: _vm.pageSize,
                                      callback: function ($$v) {
                                        _vm.pageSize = $$v
                                      },
                                      expression: "pageSize",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-btn",
                                {
                                  staticClass: "mx-2",
                                  attrs: {
                                    icon: "",
                                    large: "",
                                    disabled: _vm.disablePrevious,
                                  },
                                  on: { click: _vm.previous },
                                },
                                [_c("v-icon", [_vm._v("mdi-chevron-left")])],
                                1
                              ),
                              _c("small", [_vm._v("Page " + _vm._s(_vm.page))]),
                              _c(
                                "v-btn",
                                {
                                  staticClass: "mx-2",
                                  attrs: {
                                    icon: "",
                                    large: "",
                                    disabled: _vm.disableNext,
                                  },
                                  on: { click: _vm.next },
                                },
                                [_c("v-icon", [_vm._v("mdi-chevron-right")])],
                                1
                              ),
                            ],
                            1
                          ),
                        ]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  true
                ),
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }